var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.dateRange)?_c('div',{staticClass:"body-2 no-date-range"},[_vm._v("None")]):_c('div',[_c('div',{staticClass:"overline date-range-type"},[_vm._v(_vm._s(_vm.rangeType))]),_c('div',{staticClass:"caption date-range-value"},[_vm._v(_vm._s(_vm.rangeValue))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }